<template>
  <div class="success-message">
    <div class="success-message__confetti">
      <div
        class="success-message__confetti-piece"
        v-for="(confetti, index) in 20"
        :key="index"
      ></div>
    </div>
    <div class="success-message__content">
      <div class="success-message__icon">
        <img src="~@/assets/images/success-checked.svg" alt="Icon">
      </div>
      <h2 class="success-message__title">Erledigt</h2>
      <p class="success-message__text">Sie werden in den nächsten Sekunden eine E-Mail erhalten, bitte beachten Sie, dass das Email im Spam Ordner landen kann</p>
      <button @click="$emit('close')" class="button button--primary">zu den Buchungen</button>
    </div>
  </div>
</template>

<script>
  import {mapActions} from "vuex";

  export default {
    name: "AppSuccessMessage",
    methods: {
      ...mapActions('bookEvents', ['setCurrentEvent']),
    }
  }
</script>
